import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import ExerciseSaleView from "./ExerciseSaleView";
import StepperComponent from "../../shared/StepperComponent";
import FinalizePage from "../FinalizePage";
import useExerciseSale from "./hooks/useExerciseSale";
import ExerciseSaleTicket from "./ExerciseSaleTicket";
import { getReservationConfig } from "../../store/config/configActions";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { setActiveStep } from "../../store/basket/basketActions";
import { FACILITY } from "../../api/useUrlApi";
import { SEAT_SALE } from "../../Routing/routes";
import qs from "qs";

const container = { padding: "2%", minHeight: "70vh", width: "95%", overflow: "hidden" };
const lengthStepper = 3;

const ExerciseSale: React.FC<RouteComponentProps> = (props) => {
  const dispatch = useDispatch();
  const activeStep = useSelector((state: State) => state.basket.activeStep);
  const facility = sessionStorage.getItem(FACILITY);
  const { loading, exercisesSale, searchParams, ticketList, getTicket, addTicket } = useExerciseSale(props);
  const exerciseIds = qs.parse(props.location.search.slice(1)).exerciseIds as string;

  useEffect(
    () => {
      dispatch(getReservationConfig());
    }, // eslint-disable-next-line
    []
  );

  useEffect(() => {
    if (facility) {
      if (JSON.parse(facility) === "lubinHala") {
        if (exerciseIds) {
          props.history.push(`${SEAT_SALE}?exerciseIds=${exerciseIds}`);
        } else {
          props.history.push(SEAT_SALE);
        }
      }
    }
    // eslint-disable-next-line
  }, [facility, exerciseIds]);

  const steps = [
    {
      label: "Wybór terminu",
      component: (
        <ExerciseSaleView
          {...props}
          activeStep={activeStep}
          setActiveStep={(value: number) => dispatch(setActiveStep(value))}
          lengthStepper={lengthStepper}
          loading={loading}
          exercisesSale={exercisesSale}
          searchParams={searchParams}
          getTicket={getTicket}
        />
      ),
    },
    {
      label: "Wybór biletów dla wybranych terminów",
      component: (
        <ExerciseSaleTicket
          activeStep={activeStep}
          lengthStepper={lengthStepper}
          setActiveStep={(value: number) => dispatch(setActiveStep(value))}
          loading={loading}
          ticketList={ticketList}
          addTicket={addTicket}
        />
      ),
    },
    {
      label: "Finalizacja transakcji",
      component: (
        <FinalizePage
          {...props}
          action={"pay"}
        />
      ),
    },
  ];
  return (
    <Box style={container}>
      <StepperComponent
        steps={steps}
        activeStep={activeStep}
        setActiveStep={(value: number) => dispatch(setActiveStep(value))}
      />
    </Box>
  );
};

export default ExerciseSale;
